document.querySelectorAll('[data-five-product]').forEach(root => {
  if (root.dataset.fiveReady) return;
  root.dataset.fiveReady = 'true';
  const variant = root.querySelector('[data-five-variant]');
  const quantities = [...root.querySelectorAll('[data-five-quantity]')];
  const money = cents => new Intl.NumberFormat('en-US', {style: 'currency', currency: window.Shopify?.currency?.active || 'USD'}).format(cents / 100);
  const selectedVariant = () => variant?.tagName === 'SELECT' ? variant.selectedOptions[0] : variant;
  const quantity = () => {
    const field = quantities.find(el => el.type === 'radio' ? el.checked : true);
    return Math.max(1, Math.min(20, Math.floor(Number(field?.value) || 1)));
  };
  let adding = false;
  const update = () => {
    const option = selectedVariant();
    if (!option) return;
    const count = quantity();
    quantities.filter(el => el.type === 'number').forEach(el => el.value = String(count));
    const unitCents = Number(option.dataset.cents);
    const baseTotal = unitCents * count;
    const discount = count >= 2 ? Number(root.dataset.discountPercent || 0) : 0;
    // Match the automatic discount observed in Shopify: round the discount
    // down per supplier set, then multiply the discounted unit price.
    const unitDiscount = Math.floor(unitCents * discount / 100 + 1e-7);
    const total = (unitCents - unitDiscount) * count;
    const savings = root.querySelector('[data-five-savings]');
    if (savings) savings.textContent = discount ? `Quantity saving: ${money(baseTotal - total)}.` : '';
    root.querySelectorAll('[data-five-price],[data-five-final-price]').forEach(el => el.textContent = money(total) + (count > 1 ? ' total' : ''));
    const finalId = root.querySelector('[data-five-final-id]');
    const finalQuantity = root.querySelector('[data-five-final-quantity]');
    if (finalId) finalId.value = option.value;
    if (finalQuantity) finalQuantity.value = String(count);
    root.querySelectorAll('[data-five-add],[data-five-final-add]').forEach(el => {
      el.disabled = adding || option.dataset.available !== 'true';
      el.textContent = option.dataset.available === 'true' ? (count > 1 ? `Add ${count} ${root.dataset.unitLabel || 'item'}s to cart` : 'Add to cart') : 'Currently unavailable';
    });
    if (variant?.tagName === 'SELECT') {
      const url = new URL(location.href);
      url.searchParams.set('variant', option.value);
      history.replaceState(null, '', url);
    }
  };
  variant?.addEventListener('change', update);
  quantities.forEach(el => {
    el.addEventListener('change', update);
    if (el.type === 'number') el.addEventListener('input', () => {
      if (el.value !== '' && Number.isInteger(Number(el.value)) && Number(el.value) >= 1 && Number(el.value) <= 20) update();
    });
  });
  update();
  const slides = [...root.querySelectorAll('[data-five-slide]')];
  const thumbs = [...root.querySelectorAll('[data-five-thumb]')];
  thumbs.forEach((button, index) => button.addEventListener('click', () => {
    slides.forEach((slide, i) => slide.hidden = index !== i);
    thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(index === i)));
  }));
  const dialog = root.querySelector('.five-zoom');
  root.querySelector('[data-five-zoom]')?.addEventListener('click', () => {
    const source = slides.find(slide => !slide.hidden)?.querySelector('img');
    if (!source || !dialog) return;
    const target = dialog.querySelector('img');
    target.src = source.currentSrc || source.src;
    target.alt = source.alt;
    dialog.showModal();
  });
  root.querySelector('[data-five-zoom-close]')?.addEventListener('click', () => dialog.close());
  dialog?.addEventListener('click', event => {if (event.target === dialog) dialog.close();});
  root.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
    const button = form.querySelector('button[type=submit]');
    if (!button) return;
    const message = document.createElement('p');
    message.setAttribute('role', 'status');
    message.setAttribute('aria-live', 'polite');
    form.append(message);
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (adding || button.disabled) return;
      adding = true; update();
      button.setAttribute('aria-busy', 'true');
      message.textContent = 'Adding your selection…';
      let added = false;
      try {
        const drawer = document.querySelector('cart-drawer');
        const sections = typeof drawer?.getSectionsToRender === 'function' ? drawer.getSectionsToRender().map(s => s.id) : [];
        drawer?.setActiveElement?.(button);
        const data = new FormData(form);
        if (sections.length) {data.set('sections', sections.join(',')); data.set('sections_url', location.pathname);}
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {method: 'POST', body: data, headers: {Accept: 'application/json'}});
        const result = await response.json();
        if (!response.ok || result.status) throw Error(result.description || 'This item is unavailable.');
        added = true;
        if (drawer && sections.length && typeof drawer.renderContents === 'function') {
          if (sections.some(id => !result.sections?.[id])) {
            const url = new URL(location.href); url.searchParams.set('sections', sections.join(','));
            const refreshed = await fetch(url, {headers: {Accept: 'application/json'}});
            if (!refreshed.ok) throw Error('Cart refresh failed');
            result.sections = await refreshed.json();
            if (sections.some(id => !result.sections[id])) throw Error('Cart refresh failed');
          }
          drawer.renderContents(result); message.textContent = '';
        } else {
          message.textContent = 'Added to your cart. ';
          const link = document.createElement('a'); link.href = (window.Shopify?.routes?.root || '/') + 'cart'; link.textContent = 'View cart'; message.append(link);
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source: 'ohmm-five'});
      } catch (error) {
        message.textContent = added ? 'Added successfully. Reload to view your updated cart; do not add again.' : error.message;
      } finally {
        adding = false; button.removeAttribute('aria-busy'); update();
      }
    });
  });
});
